import { render, staticRenderFns } from "./CountryBrand.html?vue&type=template&id=74068095&scoped=true&"
import script from "./CountryBrand.vue?vue&type=script&lang=js&"
export * from "./CountryBrand.vue?vue&type=script&lang=js&"
import style0 from "./CountryBrand.vue?vue&type=style&index=0&id=74068095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74068095",
  null
  
)

export default component.exports